/**
 * Color palette UI — color dots + picker + opacity slider.
 */

import { store } from './state';

let container: HTMLElement;
let opacitySlider: HTMLInputElement;

const DEFAULT_COLORS = ['#F4A460', '#7EC8C8', '#C8E67E', '#D1A3D1'];

export function initColorPalette(): void {
  container = document.getElementById('color-dots') as HTMLElement;
  opacitySlider = document.getElementById('opacity-slider') as HTMLInputElement;
  if (!container) return;

  render();

  if (opacitySlider) {
    opacitySlider.addEventListener('input', () => {
      const palette = store.get().colors;
      store.set({
        colors: { ...palette, opacity: parseInt(opacitySlider.value) / 100 },
      });
      triggerConvert();
    });
  }
}

function render(): void {
  container.innerHTML = '';
  const palette = store.get().colors;
  const colors = palette.colors.length > 0 ? palette.colors : [];

  // Color dots
  for (let i = 0; i < colors.length; i++) {
    const dot = document.createElement('button');
    dot.className = 'color-dot';
    dot.style.backgroundColor = colors[i];
    dot.setAttribute('aria-label', `Color ${i + 1}`);

    // X icon for removal on hover
    const xIcon = document.createElement('span');
    xIcon.className = 'color-dot-x';
    xIcon.textContent = '\u00d7';
    xIcon.addEventListener('click', (e) => {
      e.stopPropagation();
      const newColors = colors.filter((_, idx) => idx !== i);
      store.set({ colors: { ...palette, colors: newColors } });
      render();
      triggerConvert();
    });
    dot.appendChild(xIcon);

    // Click to open color picker positioned above the dot
    dot.addEventListener('click', () => {
      const picker = document.createElement('input');
      picker.type = 'color';
      picker.value = colors[i];
      picker.style.position = 'fixed';
      picker.style.opacity = '0';
      picker.style.pointerEvents = 'none';

      // Position relative to the clicked dot
      const rect = dot.getBoundingClientRect();
      picker.style.left = `${rect.left}px`;
      picker.style.top = `${rect.top - 10}px`;

      document.body.appendChild(picker);

      picker.addEventListener('input', () => {
        const newColors = [...colors];
        newColors[i] = picker.value;
        store.set({ colors: { ...palette, colors: newColors } });
        render();
        triggerConvert();
      });
      picker.addEventListener('change', () => {
        document.body.removeChild(picker);
      });
      picker.click();
    });

    container.appendChild(dot);
  }

  // Add button
  if (colors.length < 6) {
    const addBtn = document.createElement('button');
    addBtn.className = 'color-dot color-dot-add';
    addBtn.textContent = '+';
    addBtn.setAttribute('aria-label', 'Add color');
    addBtn.addEventListener('click', () => {
      const unused = DEFAULT_COLORS.filter((c) => !colors.includes(c));
      const newColor = unused[0] ?? '#888888';
      const newColors = [...colors, newColor];
      store.set({ colors: { ...palette, colors: newColors } });
      render();
      triggerConvert();
    });
    container.appendChild(addBtn);
  }
}

function triggerConvert(): void {
  document.dispatchEvent(new CustomEvent('ex-mermaid:convert'));
}
